import { fetchAuthSession } from "@aws-amplify/auth";
export const createAuthService = () => {
    return {
        id: "auth-service",
        create: () => ({
            "1.0.0": () => {
                return {
                    featureService: {
                        jwtToken: async () => (await fetchAuthSession()).tokens?.accessToken?.toString() ||
                            "",
                    },
                };
            },
        }),
    };
};
